module.exports = __webpack_public_path__ + "img/baston.e6fb5bc3.svg";